/* eslint no-unused-vars: "error"*/
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Row, Col, Button } from 'react-bootstrap';
import {
  MultiStationContextProvider,
  useMultiStationContext,
} from '@components/Graphs/MultiStation/MultiStationContext';
import DataFilter from '@components/Graphs/MultiStation/DataFilter';
import { TableDataDownloadButton } from '@components/dataTables/helpers/dataProcess';
import { AwpContainer } from '@components/Common/AwpContainer';
import { selectFullScreen, toggle } from '@awp/stores/fullScreenSlice';
import ManualDataValidationRenderer from '@components/ManualDataValidation/ManualDataValidationRenderer';
import { Crud } from '@awp/shared/Crud';

const ManualDataValidation = () => {
  return (
    <AwpContainer fluid={true}>
      <MultiStationContextProvider isForGraph={false}>
        <ManualDataValidationWrapper />
      </MultiStationContextProvider>
    </AwpContainer>
  );
};

const ManualDataValidationWrapper = () => {
  const { weatherStations, weatherStationId, presetId, setForecastWeatherStationId, hasDeferWeatherStation } =
    useMultiStationContext();
  const dispatch = useDispatch();
  const toggleHeader = () => dispatch(toggle());

  const [weatherStationIndex, setWeatherStationIndex] = useState(0);
  const fullScreen = useSelector(selectFullScreen);

  const crud = new Crud('Manual Data Validation');

  useEffect(() => {
    //when the preset changes, we need to reset the selected station and index
    setForecastWeatherStationId(null);
    if (hasDeferWeatherStation && weatherStationId > 0 && weatherStations.length > 0) {
      setWeatherStationIndex(weatherStations.findIndex((station) => station.Id === weatherStationId));
    } else {
      setWeatherStationIndex(0);
    }
  }, [presetId]);

  useEffect(() => {
    setForecastWeatherStationId(weatherStations[weatherStationIndex]?.Id);
  }, [weatherStations, weatherStationIndex]);

  useEffect(() => {
    if (!weatherStationId || weatherStationId === -1 || !weatherStations) return;
    if (weatherStationId > 0 && weatherStations.length > 0) {
      setWeatherStationIndex(weatherStations.findIndex((station) => station.Id === weatherStationId));
    }
  }, [weatherStationId]);

  return (
    <div style={{ position: 'relative' }}>
      <div className="container mt-4" style={{ position: 'relative', flex: '1' }}>
        <Row>
          <Col lg={6} md={6} sm={4}>
            {crud.getHeader()}
          </Col>
          <Col lg={6} md={6} sm={8}>
            <div className="flex-grow-1 text-right d-lg-block">
              <TableDataDownloadButton tableKey="manual-data-validation" />
              <Button variant="secondary" onClick={toggleHeader}>
                {fullScreen.enabled ? 'Exit Full Screen' : 'Full Screen'}
              </Button>
            </div>
          </Col>
        </Row>
      </div>
      {!fullScreen.enabled && <DataFilter />}
      <ManualDataValidationRenderer />
    </div>
  );
};

export default ManualDataValidation;
